import { request } from '@/api/axios';

export function listCustomBranches(data) {
  return request({
    url: '/api/access/pb/cmd/BuildServer/BuildService/ListCustomBranches',
    data,
    showLoading: false,
  });
}
